import Service from "../../service/index";


const Hospital = {
    namespaced: true,
    state: {
        hospital: [],
        listDoctor:[],
    },
    mutations: {
        GET_HOSPITAL: (state, data) => {
            state.hospital = data;
        },
        SET_LIST_DOCTOR:(state,data)=>{
            state.listDoctor = data;
        }
    },
    actions: {
        setHospital({commit}){
            return Service.Hospital.getHospital()
                .then(data=>{
                    commit("GET_HOSPITAL",data);
                })
        },
        onGetListDoctor({commit},hospital_code) {
            return Service.Hospital.getListDocctor(hospital_code).then((res)=>{
                console.log("res",res)
                commit("SET_LIST_DOCTOR",res);
                return res
                })
        },
        onCreateListDoctor({commit},data) {
            return Service.Hospital.createListDocctor(data).then((res)=>{
                console.log("res",res)
                commit("SET_LIST_DOCTOR",res);
                return res
            })
        },
        onUpdateListDoctor({commit},data) {
            return Service.Hospital.updateListDocctor(data).then((res)=>{
                console.log("res message",res.message)
                commit("SET_LIST_DOCTOR",res);
                return res
            })
        },
        onDeleteListDoctor({commit},data) {
            return Service.Hospital.deleteListDocctor(data).then((res)=>{
                console.log("res",res)
                commit("SET_LIST_DOCTOR",res);
                return res
            })
        }
    }
};
export default Hospital;
